import React, { memo } from 'react';
import './index.less';
import { Tooltip } from 'antd';
import { useLottie } from 'lottie-react';
import animationData from '@/pages/prediction-score/predict.json';
import { InfoCircleOutlined } from '@ant-design/icons';
import type { IPredictionScoreExamPointDetail } from '@/types';

const lottieOptions = {
    animationData: animationData,
    loop: true,
};

const lottieStyle: React.CSSProperties = {
    width: 62,
    height: 62,
};

interface IProps {
    data: IPredictionScoreExamPointDetail;
}

const AiEfficiency: React.FC<IProps> = ({ data }) => {
    const { View } = useLottie(lottieOptions, lottieStyle);

    return (
        <div className="sub-tiku__ai-efficiency">
            {View}
            <div className="sub-tiku__ai-efficiency-title-wrap">
                <div className="sub-tiku__ai-efficiency-title">
                    <span dangerouslySetInnerHTML={{ __html: data.efficiency }}></span>
                    <Tooltip
                        placement="bottom"
                        classNames={{
                            root: 'sub-tiku__ai-efficiency-tooltip_root',
                            body: 'sub-tiku__ai-efficiency-tooltip_body',
                        }}
                        title={data.efficiencyDesc}
                    >
                        <span className="sub-tiku__ai-efficiency-icon">
                            <InfoCircleOutlined />
                        </span>
                    </Tooltip>
                </div>
                <div className="sub-tiku__ai-efficiency-notice">{data.efficiencyNotice}</div>
            </div>
        </div>
    );
};

export default memo(AiEfficiency);
